import { deepFind } from 'react-children-utilities'
import rem from '@/utils/rem.js'

const Avatar = () => null
const Title = () => null
const Subtitle = () => null
const Footer = () => null

const CardSystem = ({ children }) => {
	const avatar = deepFind(children, (child) => child.type === Avatar)
	const title = deepFind(children, (child) => child.type === Title)
	const subtitle = deepFind(children, (child) => child.type === Subtitle)
	const footer = deepFind(children, (child) => child.type === Footer)

	return (
		<div className="card-system">
			<div className="card-system__header">
				<div className="card-system__profile">
					<div className="card-system__profile__left">
						{avatar && avatar.props.children}
					</div>
					<div className="card-system__profile__right">
						{title && (
							<div className="card-system__profile__title">
								{title.props.children}
							</div>
						)}

						{subtitle && (
							<div className="card-system__profile__subtitle">
								{subtitle.props.children}
							</div>
						)}
					</div>
				</div>
			</div>
			<div className="card-system__footer">
				{footer && <div>{footer.props.children}</div>}
			</div>
		</div>
	)
}

CardSystem.Avatar = Avatar
CardSystem.Title = Title
CardSystem.Subtitle = Subtitle
CardSystem.Footer = Footer

export default CardSystem
